import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ServerService {
  constructor(private http: HttpClient) {}

  connection(): Observable<any> {
    const url = `${environment.url.api}/connection`;
    return this.http.get<any>(url).pipe(timeout(environment.config.apiWaitingTime));
  }
}
